import { LazyMotion, MotionConfig } from 'framer-motion'
import { ReactNode } from 'react'

// ----------------------------------------------------------------------
// Reduced motion has two halves. The CSS half lives in one media block in
// `theme/motion.ts`; this is the other half. Framer Motion animates transform
// and opacity by writing inline styles every frame, which no media query can
// reach, so `reducedMotion="user"` is what stops those animations for an
// operator who asked for less movement.
// ----------------------------------------------------------------------

// eslint-disable-next-line import/extensions
const loadFeatures = () => import('./features.js').then((res) => res.default)

type Props = {
  children: ReactNode
}

export default function MotionLazyContainer({ children }: Props) {
  return (
    <MotionConfig reducedMotion="user">
      <LazyMotion strict features={loadFeatures}>
        {children}
      </LazyMotion>
    </MotionConfig>
  )
}
